// extracted by mini-css-extract-plugin
export default {"button-box":"FinishExamButtonBox_button-box__2QovE","finish-button":"FinishExamButtonBox_finish-button__2EsKR"};